import { Box, CssBaseline } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useState } from 'react';
import useAuthStore from '../../store/auth';

interface AppLayoutProps {
  children: React.ReactNode;
}

const drawerWidth = 240;

export const AppLayout = ({ children }: AppLayoutProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  if (!isAuthenticated) {
    return <Box sx={{ minHeight: '100vh' }}>{children}</Box>;
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <CssBaseline />
      <Navbar onMenuClick={handleDrawerToggle} />
      <Sidebar open={drawerOpen} onClose={handleDrawerToggle} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, sm: 3 },
          mt: 8,
          display: 'flex',
          justifyContent: 'center',
          minHeight: 'calc(100vh - 64px)',
          marginLeft: { sm: drawerOpen ? `${drawerWidth}px` : 0 },
          transition: (theme) =>
            theme.transitions.create('margin', {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: { xs: '100%', sm: '1200px', md: '1400px' },
            px: { xs: 1, sm: 2 },
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};